import React from "react";
import { Link } from "react-router-dom";
import { courseHighlights } from "../../data/mockData";
import { ArrowRight } from "lucide-react";
import useInView from "../../hooks/useInView";

const CourseHighlightsSection = () => {
  const [highlightsRef, highlightsInView] = useInView();

  return (
    <section ref={highlightsRef} className="py-24 bg-[#f8f7f4]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-[#C9A96E] text-sm font-medium tracking-[0.2em] uppercase">
            The Course
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1B2A4A] mt-3">
            Course Highlights
          </h2>
        </div>

        <div className="space-y-20">
          {courseHighlights.map((item, index) => (
            <div
              key={item.title}
              className={`flex flex-col ${
                index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
              } gap-12 items-center transition-all duration-700 ${
                highlightsInView
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${index * 200}ms` }}
            >
              <div className="flex-1">
                <div className="overflow-hidden rounded-2xl shadow-lg">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-80 object-cover hover:scale-105 transition-transform duration-700"
                  />
                </div>
              </div>
              <div className="flex-1">
                <h3 className="text-3xl font-serif font-bold text-[#1B2A4A] mb-4">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-lg">
                  {item.description}
                </p>
                <Link
                  to="/golf"
                  className="inline-flex items-center gap-2 mt-6 text-[#C9A96E] font-medium hover:gap-3 transition-all duration-300"
                >
                  Learn More <ArrowRight size={18} />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { CourseHighlightsSection };
